module.exports = __webpack_public_path__ + "static/snowball-testimonials-2-786df2da19bb5f88271677af9cc4326d.jpg";